export const PrintTranslationResource = Object.freeze({
  PAYMENT_METHOD: 'paymentMethod',
  QUANTITY_UNIT: 'quantityUnit',
  ITEM: 'item',
  COUNTRY: 'country',
  VAT_CODE: 'vatCode',
  OWN_COMPANY: 'ownCompany',
});

export const printTranslationConfig = Object.freeze({
  [PrintTranslationResource.PAYMENT_METHOD]: {
    recordKeyField: 'id',
    fields: ['name'],
  },
  [PrintTranslationResource.QUANTITY_UNIT]: {
    recordKeyField: 'id',
    fields: ['name'],
  },
  [PrintTranslationResource.ITEM]: {
    recordKeyField: 'itemCode',
    fields: ['itemName'],
  },
  [PrintTranslationResource.COUNTRY]: {
    recordKeyField: 'code',
    fields: ['name'],
  },
  [PrintTranslationResource.VAT_CODE]: {
    recordKeyField: 'code',
    fields: ['name'],
  },
  [PrintTranslationResource.OWN_COMPANY]: {
    recordKey: 'default',
    fields: ['name', 'shortName', 'nameInPrint', 'province', 'city', 'streetAddress', 'other'],
  },
});
